<template>
  <v-data-table
    no-data-text="Sem dados"
    :headers="headers"
    :items="items"
    :footer-props="{
      'items-per-page-text': 'Linhas por página',
      'page-text': '{0}-{1} de {2}',
      'items-per-page-all-text': 'Todos',
    }"
    :items-per-page="5"
  >
    <template #[`item.dataCadastro`]="{ item }">
      {{ functions.converterDateTimeStringEmLocaleDateTimeString(item.dataCadastro) }}
    </template>

    <template #[`item.nomeStatus`]="{ item }">
      <v-chip
        class="v-chip-light-bg font-weight-semibold text-capitalize"
        small
        :class="`${resolveStatisticsIconVariation(item.nomeCategoriaStatus).color}--text`"
        :color="resolveStatisticsIconVariation(item.nomeCategoriaStatus).color"
      >
        {{ item.nomeStatus }}
      </v-chip>
    </template>

    <template #[`item.actions`]="{ item }">
      <v-btn
        icon
        class="ml-5"
        color="primary"
        :to="{
          name: 'front-atendimento-gestor',
          params: { },
          query: { filaId: item.idFila, filaNome: item.nomeFila, activeTab: 2, ticketProtocolo: item.protocolo },
        }"
        target="_blank"
      >
        <v-icon>{{ icons.mdiEyeOutline }}</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { mdiEyeOutline, mdiAccountOutline, mdiTrendingUp, mdiAccountCheck, mdiAccountClock, mdiAccountPlus } from '@mdi/js'
import { converterDateTimeStringEmLocaleDateTimeString } from '@/utils/dateTime'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  setup() {
    const resolveStatisticsIconVariation = data => {
      if (data === 'Total') return { icon: mdiTrendingUp, color: 'secondary' }
      if (data === 'Novo') return { icon: mdiAccountPlus, color: 'success' }
      if (data === 'Andamento') return { icon: mdiAccountClock, color: 'accent' }
      if (data === 'Resolvido') return { icon: mdiAccountOutline, color: 'warning' }
      if (data === 'Finalizado') return { icon: mdiAccountCheck, color: 'error' }

      return { icon: mdiAccountOutline, color: 'success' }
    }

    const headers = [
      { text: 'Data cadastro', value: 'dataCadastro' },
      { text: 'Protocolo', value: 'protocolo' },
      {
        text: 'Ver',
        value: 'actions',
        align: 'center',
      },
      { text: 'Status', value: 'statusNome', align: 'center' },
    ]

    return {
      resolveStatisticsIconVariation,
      headers,
      functions: {
        converterDateTimeStringEmLocaleDateTimeString,
      },
      icons: {
        mdiEyeOutline,
      },
    }
  },
}
</script>
